import {View, Text, Image} from 'react-native';
import React from 'react';
import {styles} from './styles';
import {Images} from '../../../../constants/Images';
import CheckBoxLimit from './CheckBoxLimit/ChecBoxLimit';

interface ILimitAlert {
  balance: number;
}
const LimitAlert = ({balance}: ILimitAlert) => {
  return (
    <View style={styles.container}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
        }}>
        <Image source={Images.warningB} style={styles.image} />
        <Text
          style={{
            fontSize: 12,
            lineHeight: 16,
            fontFamily: 'TCCC-UnityText Bold',
            color: 'black',
          }}>
          Limite de crédito disponível:{' '}
          {balance.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}
        </Text>
      </View>
      <Text
        style={{
          fontSize: 12,
          lineHeight: 16,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        Seu pedido ficou acima do seu limite de crédito disponivel!
      </Text>
      <Text
        style={{
          fontSize: 12,
          lineHeight: 16,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        Para finalizá-lo, faça o pagamento via PIX ou cartão de crédito ou
        revise os itens do seu carrinho e desfrute do seu crédito na Brasal
        Refrigerantes.
      </Text>
    </View>
  );
};

export default LimitAlert;
